import { createContext, useMemo } from "react";

import {
    CompanyFilterContextState,
    CompanyFilterStateProps
} from "./types/interfaces";

export const CompanyFilterContext = createContext(
    {} as CompanyFilterContextState
);

const CompanyFilterState = ({
    children,
    isLoading,
    isDialogOpen,
    anchorEl,
    rootCompanyType,
    closeDialog,
    closeMenu,
    setRootCompanyType
}: CompanyFilterStateProps) => {
    const value = useMemo(
        () => ({
            isLoading,
            isDialogOpen,
            anchorEl,
            rootCompanyType,
            closeDialog,
            closeMenu,
            setRootCompanyType
        }),
        [
            isLoading,
            isDialogOpen,
            anchorEl,
            rootCompanyType,
            closeDialog,
            closeMenu,
            setRootCompanyType
        ]
    );

    return (
        <CompanyFilterContext.Provider value={value}>
            {children}
        </CompanyFilterContext.Provider>
    );
};

export default CompanyFilterState;
